import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule, NoPreloading } from '@angular/router';
import { AboutusComponent } from './aboutus/aboutus.component';
import { BlogComponent } from './blog/blog.component';
import { ContactusComponent } from './contactus/contactus.component';
//import { PublicRFQComponent } from './public_rfq/public_rfq.component';
import { CareerComponent } from './career/career.component';
import { FaqComponent } from './faq/faq.component';
import { ForgotpassComponent } from './forgotpass/forgotpass.component';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { TermsComponent } from './terms/terms.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ForbuyerComponent } from './forbuyer/forbuyer.component';
import { ForvendorComponent } from './forvendor/forvendor.component';
import { CustomfgComponent } from './blog/customfg/customfg.component';
import { VdsComponent } from './blog/vds/vds.component';
import { CofounderComponent } from './blog/cofounder/cofounder.component';
import { SupplychainComponent } from './blog/supplychain/supplychain.component';
import { Budget2021Component } from './blog/budget2021/budget2021.component';
import { GyvbComponent } from './blog/gyvb/gyvb.component';
import { BehindsComponent } from './blog/behinds/behinds.component';
import { LandingpagesComponent } from './home/landingpages/landingpages.component';
import { ManufacturingComponent } from './blog/manufacturing/manufacturing.component';
import { TestimonialsComponent } from './home/testimonials/testimonials.component';
import { StrategicpartnerComponent } from './home/strategicpartner/strategicpartner.component';
import { GlobalComponent } from './global/global.component';
import { NewSignupFormComponent } from './home/new-signup-form/new-signup-form.component';
import { NewSigninFormComponent } from './home/new-signin-form/new-signin-form.component';
import { ProcurementComponent } from './blog/procurement/procurement.component';
import { NewPricingPageComponent } from './new-pricing-page/new-pricing-page.component';
//import { BiddingSignupComponent } from './home/bidding-signup/bidding-signup.component';
import { CustomerwinsComponent } from './home/customerwins/customerwins.component';
import { MachiningComponent } from './machining/machining.component';
import { CastingComponent } from './casting/casting.component';
import { FabricationComponent } from './fabrication/fabrication.component';
import { ForgingComponent } from './forging/forging.component';
import { PressingComponent } from './pressing/pressing.component';
import { WebinarliveComponent } from './webinarlive/webinarlive.component';



const routes: Routes = [
  
  
  
  {
    path: "",
    component: LandingpagesComponent,
    pathMatch: "full",
    data: {

      seo:{

      title:"Get Your Vendor -Best B2B Manufacturing Facility Search Portal | GYV",
      
      metaTags:[
        { name: 'description', content: 'Get Your Vendor the best b2b manufacturing marketplace connects vendors and buyers towards facilitating manufacturing multiple categories, which would streamline into global sourcing and custom manufacturing.'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'custom-manufacturing,e-commerce'},
      ]
    
        
        }  
    
    }
  },
  
  {
    path: "dashboard",
    loadChildren: () =>
      import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
  },  
  {
    path: "login",
    loadChildren: () =>
      import("./login/login.module").then((m) =>{ return m.LoginModule;}),

      data: {

        seo:{
  
        title:"Login | Get Your Vendor ",
        
        metaTags:[
          { name: 'description', content: 'Get Your Vendor the best b2b manufacturing marketplace connects vendors and buyers towards facilitating manufacturing multiple categories, which would streamline into global sourcing and custom manufacturing.'},
          { name:'robots', content:'noindex, nofollow'},
          {name:'keywords',content:'custom-manufacturing,e-commerce'},
        ]
      
          
          }  
      
      }
  },
  {
    path: "forgotpassword",
    component: ForgotpassComponent,
    pathMatch: "full",

    data:{

      seo:{

        title:"Forgot Password | Get Your Vendor",
      }
    }
  },
  
  {
    path: "contactus",
    component: ContactusComponent,
    pathMatch: "full",

    data: {

      seo:{

      title:"Contact us | Get Your Vendor",
      
      metaTags:[
        { name: 'description', content: 'Contact us for global sourcing and custom manufacturing.'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'custom-manufacturing,contact'},
      ]
    
        
        }  
    
    }
  },

  {
    path: "career",
    component: CareerComponent,
    pathMatch: "full",
    data: {

      seo:{

      title:"Career | Get Your Vendor",
      
      metaTags:[
        { name: 'description', content: 'This is a unique opportunity to work on innovative and disruptive technology-driven business solutions that are shaping the future of the manufacturing industry.'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'jobs,open positions,career'},
      ]
    
        
        }  
    
    }
  },

  {
    path: "aboutus",
    component: AboutusComponent,
    pathMatch: "full",

    data: {

      seo:{

      title:"About Us | Get Your Vendor",
      
      metaTags:[
        {name: 'description', content: 'Get Your Vendor the best b2b manufacturing marketplace '},
        { property: 'og:title', content: 'GYV AboutUs' },
        { proprety: 'og:description', content: 'Custom' },
       
        { property: 'og:url', content: GlobalComponent.hostName + '/aboutus' },
        {name:'robots', content:'index, follow'},
        {name:'keywords', content:'aboutus'},
      ]
    
        
        }  
    
    }
  },

  {
    path: "blog",
    component: BlogComponent,
    pathMatch: "full",
    data: {

      seo:{

      title:"Blogs | Get Your Vendor",
      
      metaTags:[
        { name: 'description', content: 'Blogs and articles by our technical team on innovative thinking - Get your Vendor'},
        { name:'robots', content:'index, nofollow'},
        {name:'keywords',content:'custom-manufacturing,e-commerce, vendor management'},
      ]
    
        
        }  
    
    }
  },

  {
    path: "faq",
    component: FaqComponent,
    pathMatch: "full",
    data: {

      seo:{

      title:"Frequently Asked Questions | Get Your Vendor",
      
      metaTags:[
        { name: 'description', content: 'Get Your Vendor the best b2b manufacturing marketplace.'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'faq,subcription plan'},
      ]
    
        
        }  
    
    }
  },


  { path: "demo-signup", 
    component:  NewSignupFormComponent,
    pathMatch: "full", 
  },

  { path: "newpricingpage", 
    component: NewPricingPageComponent,
    pathMatch: "full", 
    data: {

      seo:{

      title:"Pricing Page | Get Your Vendor",
      
      metaTags:[
        { name: 'description', content: 'Get Your Vendor the best b2b manufacturing marketplace.'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'Subcription plan, Pricing'},
      ]
    
        
        }  
    
    }
  },

  { path: "new-signin-form", 
    component:  NewSigninFormComponent,
    pathMatch: "full", 
  },
  



  {
    path: "terms",
    component: TermsComponent,
    pathMatch: "full",
    data: {

      seo:{

      title:"Terms of use | Get Your Vendor",
      
      metaTags:[
        { name: 'description', content: 'All users must read and understand the Terms of Get Your Vendor as it has been formulated to safeguard the Indisourcing Terms.'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'terms,legal'},
      ]
    
        
        }  
    
    }
  },
  {
    path: "privacy-policy",
    component: PrivacyComponent,
    pathMatch: "full",
    data: {

      seo:{

      title:"Privacy Policy | Get Your Vendor",
      
      metaTags:[
        { name: 'description', content: 'All users must read and understand the Privacy Policy of Get Your Vendor as it has been formulated to safeguard the user’s privacy or Privacy Policy.'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'privacy,legal'},
      ]
    
        
        }  
    
    }
  },

  
  {
    path: "signup",
    loadChildren: () =>
      import("./login/login.module").then((m) => m.LoginModule),
      data: {

        seo:{
  
        title:"Get Your Vendor | Signup",
        
        metaTags:[
          { name: 'description', content: 'Get Your Vendor the best b2b manufacturing marketplace connects vendors and buyers towards facilitating manufacturing multiple categories, which would streamline into global sourcing and custom manufacturing.'},
          { name:'robots', content:'noindex, nofollow'},
          {name:'keywords',content:'custom-manufacturing,Signup'},
        ]
      
          
          }  
      
      }
  },
  {
    path:"buyersbenefits",
    component: ForbuyerComponent,
    pathMatch:"full",
    data: {

      seo:{

      title:"Buyers Benefits| Get Your Vendor",
      
      metaTags:[
        { name: 'description', content: 'Get Your Vendor is a user-friendly platform where Indian and overseas buyers of manufacturing can post their needs in order to connect with Indian and global manufacturers.'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'manufacturing,products'},
      ]
    
        
        }  
    
    }

  },
  { path:"vendorsbenefits",
    component : ForvendorComponent,
    pathMatch: "full",

    data: {

      seo:{

      title:"Vendor Benefits | Get Your Vendor",
      
      metaTags:[
        { name: 'description', content: ' GetYourVendor is a user-friendly platform for Indian and International manufacturing Vendors/Suppliers to connect with Indian and global manufacturing Buyers.'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'manufacturing,products'},
      ]
    
        
        }  
    
    }
  },
  {
    path:"blog/Custom-Manufacturing-The-USP-of-distinctive-brands",
    component: CustomfgComponent,
    pathMatch :"full",

    data: {

      seo:{

      title:"Custom manufacturing USP to boost your business | Get Your Vendor",
      
      metaTags:[
        { name: 'description', content: 'The manufacturing or vendor can make or break a business – find a custom manufacturer to help you stand out in a crowd!'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'manufacturing,products'},
      ]
    
        
        }  
    
    }
  },
  { 
    path:"blog/Vendor-Development-strategic-sourcing",
    component : VdsComponent,
    pathMatch: "full",
    data: {

      seo:{

      title:"Benefits of Vendor Development Strategic Sourcing | Get Your Vendor",
      
      metaTags:[
        { name: 'description', content: 'Strategic sourcing for vendor development involves being current on market trends, altering customer demand, new business models, and technical developments.'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'manufacturing,products'},
      ]
    
        
        }  
    
    }
  },
  {
    path:"blog/First-Year-as-a-founder",
    component:CofounderComponent,
    pathMatch: "full",
    data: {

      seo:{

      title:"The best solution for Indian Manufacturing Companies | Get Your Vendor ",
      
      metaTags:[
        { name: 'description', content: 'The idea to form Indisourcing Solutions Pvt. Ltd. with like-minded people was to deliver the best solution for Indian manufacturing companies.'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'indian ,manufacturing,sme'},
      ]
    
        
        }  
    
    }
  },
  {
    path: "blog/4-Tips-To-Optimize-Your-Supply-Chain-Cost",
    component: SupplychainComponent,
    pathMatch: "full",
    data: {

      seo:{

      title:"Optimize supply chain cost with 4 strategic steps | Get Your Vendor",
      
      metaTags:[
        { name: 'description', content: 'One of the key KPIs for every manager in a firm is cost minimization in the supply chain. If done incorrectly, it poses a serious threat to any companys finances and expansion.'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'indian ,manufacturing,sme'},
      ]
    
        
        }  
    
    }
  },
  {
    path: "blog/Budget-2021-What-does-it-have-in-store-for-the-Manufacturing-Industry",
    component: Budget2021Component,
    pathMatch: "full",
    data: {

      seo:{

      title:"How will the budget for 2021 affect the manufacturing sector?",
      
      metaTags:[
        { name: 'description', content: 'Times were uncertain, businesses were on the brink of oblivion and there was no solution in sight – in such turbulent circumstances, all eyes were on Budget-2021 in hopes that it would help the Manufacturing industry get back on its feet.'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'indian ,manufacturing,sme'},
      ]
    
        
        }  
    
    }
  },
  {
    path:"blog/Procurement-Management-System",
    component: GyvbComponent,
    pathMatch: "full",
    data: {

      seo:{

      title:"Procurement management platform to get your vendor",
      
      metaTags:[
        { name: 'description', content: 'Procurement managers, Sourcing teams and Design engineers spend a lot of time searching and evaluating vendors. This kind of analysis and research involves heavy costs both in terms of time and money.'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'indian ,manufacturing,sme'},
      ]
    
        
        }  
    
    }
  },
  {
    path: "blog/The-Manufacturing-Industry-Challenges-Opportunities-&-Digital-Transformation",
    component: BehindsComponent,
    pathMatch: "full",
    data: {

      seo:{

      title:"Study the challenges faced by the ever-evolving Manufacturing Industry",
      
      metaTags:[
        { name: 'description', content: 'To devise 360-degree solutions, it’s important to first understand the problem! Let’s study the challenges faced by the ever-evolving Manufacturing industry and then move on to the solution'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'indian ,manufacturing,sme'},
      ]
    
        
        }  
    
    }
  },
  {
    path: "blog/How-to-Find-Reliable-Indian-Manufacturing-Vendors",
    component: ManufacturingComponent,
    pathMatch: "full",
    data: {

      seo:{

      title:"4 steps to find your reliable Indian Manufacturer",
      
      metaTags:[
        { name: 'description', content: 'If you are planning to sell your products in India, in that case, you might be willing to connect with vendors that can act as manufacturers, distributors, and wholesalers lets directly delve into ways you can connect with local vendors to manufacture in India.'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'manufacturing,products'},
      ]
    
        
        }  
    
    }
  },
  {
    path: "blog/Why-Procurement-Needs-To-Look-Beyond-The-Traditional-Methods",
    component: ProcurementComponent,
    pathMatch: "full",
    data: {

      seo:{

      title:"Why Procurement Needs To Look Beyond The Traditional Methods",
      
      metaTags:[
        { name: 'description', content: 'Its time for procurement to break free from the shackles of tradition and embark on a transformative journey towards a more agile, strategic, and value-driven future.'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'procurement,products'},
      ]
    
        
        }  
    
    }
  },



  

  {
    path: "testimonials",
    component: TestimonialsComponent,
    pathMatch: "full",
    data: {

      seo:{

      title:"Testimonials | Get Your Vendor",
      
      metaTags:[
        { name: 'description', content: 'Users feedback for our excellent service'},
        { name:'robots', content:'index, follow'},
        { name:'keywords',content:'manufacturing,testimonials'},
      ]
    
        
        }  
    
    }

  },

  {
    path: "strategicpartner",
    component: StrategicpartnerComponent,
    pathMatch: "full",
    data: {

      seo:{

      title:"Strategic partnership Program | Get Your Vendor",
      
      metaTags:[
        { name: 'description', content: 'Get Your Vendor offers the strategic partnership program to similar interest individuals or organizations experts in the following areas: Vendor Development, Sourcing Consultants, Purchase Experts, Procurement, Distribution Organizations'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'privacy,legal'},
      ]
    
        
        }  
    
    }
  },
  {
    path: "customerwins",
    component: CustomerwinsComponent,
    pathMatch: "full",
    data: {

      seo:{

      title:"Customer Wins| Get Your Vendor",
      
      metaTags:[
        { name: 'description', content: 'GetYourVendor is committed to deliver high value projects to the smallest customers, we have proven record of multiple wins during our journey to match the RFQ and Vendor'},
        { name:'robots', content:'index, follow'},
        {name:'keywords',content:'customerwins,purchaseorder,satisfaction'},
      ]
    
        
        }  
    
    }

  },

  {
    path:"machining",
    component:MachiningComponent,
    pathMatch:"full",

    data: {

      seo:{

      title:"Machining | Get Your Vendor",
      
      metaTags:[
        {name: 'description', content: 'Machining is to remove the material to get final part'},
        { property: 'og:title', content: 'GYV Machining' },
        { proprety: 'og:description', content: 'Custom' },
       
        { property: 'og:url', content: GlobalComponent.hostName + '/machining' },
        {name:'robots', content:'index, follow'},
        {name:'keywords', content:'machining'},
      ]
    
        
        }  
    
    }

  },
  {
    path:"casting",
    component:CastingComponent,
    pathMatch:"full",

    data: {

      seo:{

      title:"Casting | Get Your Vendor",
      
      metaTags:[
        {name: 'description', content: 'Get Your Vendor the best b2b manufacturing marketplace '},
        { property: 'og:title', content: 'GYV Casting' },
        { proprety: 'og:description', content: 'Custom' },
       
        { property: 'og:url', content: GlobalComponent.hostName + '/casting' },
        {name:'robots', content:'index, follow'},
        {name:'keywords', content:'casting'},
      ]
    
        
        }  
    }
  },
  {
    path:"fabrication",
    component:FabricationComponent,
    pathMatch:"full",

    data: {

      seo:{

      title:"Fabrication | Get Your Vendor",
      
      metaTags:[
        {name: 'description', content: 'Get Your Vendor the best b2b manufacturing marketplace '},
        { property: 'og:title', content: 'GYV Fabrication' },
        { proprety: 'og:description', content: 'Custom' },
       
        { property: 'og:url', content: GlobalComponent.hostName + '/fabrication' },
        {name:'robots', content:'index, follow'},
        {name:'keywords', content:'fabrication'},
      ]
    
        
        }  
    
    }

  },
  {
    path:"forging",
    component:ForgingComponent,
    pathMatch:"full",
    data: {

      seo:{

      title:"Forging | Get Your Vendor",
      
      metaTags:[
        {name: 'description', content: 'Get Your Vendor the best b2b manufacturing marketplace '},
        { property: 'og:title', content: 'GYV Forging' },
        { proprety: 'og:description', content: 'Custom' },
       
        { property: 'og:url', content: GlobalComponent.hostName + '/forging' },
        {name:'robots', content:'index, follow'},
        {name:'keywords', content:'forging'},
      ]
    
        
        }  
    
    }

  },
  {
    path:"pressing",
    component:PressingComponent,
    pathMatch:"full",
    data: {

      seo:{

      title:"Pressing | Get Your Vendor",
      
      metaTags:[
        {name: 'description', content: 'Get Your Vendor the best b2b manufacturing marketplace '},
        { property: 'og:title', content: 'GYV Pressing' },
        { proprety: 'og:description', content: 'Custom' },
       
        { property: 'og:url', content: GlobalComponent.hostName + '/pressing' },
        {name:'robots', content:'index, follow'},
        {name:'keywords', content:'pressing'},
      ]
    
        
        }  
    
    }

  },
  

  {
    path:"webinars",
    component:WebinarliveComponent,
    pathMatch:"full",
    data: {

      seo:{

      title:"Webinars | Get Your Vendor",
      
      metaTags:[
        {name: 'description', content: 'Get Your Vendor the best b2b manufacturing marketplace '},
        { property: 'og:title', content: 'GYV Webinars' },
        { proprety: 'og:description', content: 'Custom' },
       
        { property: 'og:url', content: GlobalComponent.hostName + '/webinars' },
        {name:'robots', content:'index, follow'},
        {name:'keywords', content:'webinars'},
      ]
    
        
        }  
    
    }
  },
  {
    path: '**',
    redirectTo: '/page-not-found'
  },
  {
    path: 'page-not-found',
    component: NotFoundComponent
  },

  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
